import { cloneDeep } from 'lodash';
import { CHAT_ORDER_TAB, ORDER_STATUS } from '@/common/constants/ConstCode';
import { createSelectedRoomState } from '@/store/modules/chat/state';

export const mutations = {
  setName: (state, name) => {
    state.meta.name = name;
  },
  //stompWork
  setHeader: (state, header = { userNo: 0, accessToken: '' }) => {
    state.header = header;
  },
  setDesiredRoom: (state, roomNo = null) => {
    state.desiredRoomNo = Number(roomNo) || null;
  },
  clearDesiredRoom: (state) => {
    state.desiredRoomNo = null;
  },
  setSubscribedRoom: (state, roomNo = null) => {
    state.subscribedRoomNo = Number(roomNo) || null;
  },
  clearSubscribedRoom: (state) => {
    state.subscribedRoomNo = null;
  },
  subscribe: (state, roomNo) => {
    state.subscribedRoomNo = Number(roomNo) || null;
  },
  unsubscribe: (state) => {
    state.subscribedRoomNo = null;
  },
  appendChat: (state, message = [] || {}) => {
    state.chats.data = mergeRoomChats(state.chats.data, message, state.desiredRoomNo);
  },

  readAllMessages: (state, userNo) => {
    const chatsCopy = [...state.chats.data];
    chatsCopy.forEach((v) => {
      //메시지 주인 /  타인  && 메시지 주인 /나
      if (v.userNo !== userNo && v.userNo === state.header.userNo)
        // 남이 내 메시지를 읽은 케이스
        v.isRead = true;

      //메시지 주인 / 나  &&  나  /나
      if (v.userNo !== userNo && userNo === state.header.userNo) v.isRead = true;
    });
    state.chats.data = chatsCopy;
  },

  //ControlChatRoomScroll
  shouldIMoveScroll: (state, scroll) => {
    state.shouldIMoveScroll = scroll;
  },

  setRoomType: (state, roomType = null) => {
    state.room.roomType = roomType;
  },
  setOrderTab: (state, orderTab = null) => {
    state.room.orderTab = orderTab;
  },
  setChatTab: (state, chatTab = 'order') => {
    state.room.chatTab = chatTab;
  },

  //setRoomData
  setRoomPage: (state, page = 1) => {
    state.room.page = page;
  },
  setRoomPageNextId: (state, nextId) => {
    state.room.nextId = nextId;
  },
  setRoomTotalPage: (state, totalPage = 2) => {
    state.room.totalPage = totalPage;
  },
  setRoomData: (state, data = []) => {
    state.room.data = [...state.room.data, ...data];
  },
  replaceRoomData: (state, data = []) => {
    state.room.data = [...data];
  },

  setSelectedRoom: (state, roomNo = '') => {
    state.selectedRoom.roomNo = roomNo;
  },

  //pagingChats
  resetSelected: (state) => {
    state.selectedRoom = createSelectedRoomState();
  }, //selectedRoom
  setChatData: (state, data = []) => {
    state.chats.data = mergeRoomChats(data, state.chats.data, state.desiredRoomNo);
  },

  setImageUploadState: (state, status = false) => {
    state.imageUploadState = status;
    console.log('state.imageUploadState', state.imageUploadState);
  },

  setChatTotalPage: (state, totalPage = 2) => {
    state.chats.totalPage = totalPage;
  },
  setChatPage: (state, page = 1) => {
    state.chats.page = page;
  },

  //purge
  flushRoomData: (state) => {
    state.room.data = [];
    state.room.page = 1;
    state.room.nextId = null;
    state.room.totalPage = 2;
  },
  flushChatData: (state) => {
    state.chats.data = [];
    state.chats.page = 1;
    state.chats.totalPage = 2;
  },
  purge: (state) => {
    state.header = {
      userNo: 0,
      accessToken: ''
    };
    state.desiredRoomNo = null;
    state.subscribedRoomNo = null;
    state.selectedRoom = createSelectedRoomState();

    state.room = {
      page: 1,
      limit: 10,
      nextId: null,
      totalPage: 2,
      roomType: null,
      orderTab: null,
      chatTab: 'order',
      data: []
    };
    state.chats = {
      page: 1,
      limit: 10,
      totalPage: 2,
      data: []
    };
    state.shouldIMoveScroll = false;
  },
  selectRoom: (
    state,
    room = createSelectedRoomState()
  ) => {
    state.selectedRoom = {
      ...createSelectedRoomState(),
      ...room,
      store: room.store ?? {},
      profiles: room.profiles ?? [],
      order: room.order ?? {}
    };
  },

  //sse
  leaveRoomAtRoom: (state, roomNo) => {
    const selected = cloneDeep(state.selectedRoom);

    console.log(selected.roomNo, roomNo);
    if (selected.roomNo === roomNo) {
      selected.isChattable = false;
    }

    state.selectedRoom = selected;
  },
  leaveRoomAtLobby: (state, { roomNo }) => {
    const data = [...state.room.data];
    const idx = data.findIndex((room) => room.roomNo === roomNo);
    if (idx <= -1) return;
    data.splice(idx, 1);
    const now = new Date();
    data.sort((e1, e2) => {
      const d2 = e2?.lastBubble?.regDate
        ? new Date(e2?.lastBubble?.regDate).getTime()
        : now.getTime() - 1000 * 60 * 60 * 24 * 100;
      const d1 = e1?.lastBubble?.regDate
        ? new Date(e1?.lastBubble?.regDate).getTime()
        : now.getTime() - 1000 * 60 * 60 * 24 * 100;

      return d2 - d1;
    });
    state.room.data = data;
  },
  appendRoom: (state, room) => {
    const { chatTab, orderTab } = state.room;

    let data = [...state.room.data];
    switch (chatTab) {
      case 'inquiry':
        data = appendInquiryRoom(room, data);
        break;
      case 'order':
        data = appendOrderRoom(room, data, orderTab);
        break;
      default:
        const tmpData = appendInquiryRoom(room, data);
        data = appendOrderRoom(room, tmpData, orderTab);
        break;
    }

    const now = new Date();
    data.sort((e1, e2) => {
      const d2 = e2?.lastBubble?.regDate
        ? new Date(e2?.lastBubble?.regDate).getTime()
        : now.getTime() - 1000 * 60 * 60 * 24 * 100;
      const d1 = e1?.lastBubble?.regDate
        ? new Date(e1?.lastBubble?.regDate).getTime()
        : now.getTime() - 1000 * 60 * 60 * 24 * 100;

      return d2 - d1;
    });

    state.room.data = data;
  },
  setBubbleCounts: (state, counts) => {
    state.bubbleCounts = counts;
  },
  setLobbyOrderState: (state, { orderNo, orderState }) => {
    const data = [...state.room.data];
    const idx = data.findIndex((room) => room.orderNo === orderNo);
    const picked = data[idx];
    if (picked) {
      picked.order = {
        ...(picked.order ?? {}),
        orderNo,
        orderState
      };
      if (orderState === ORDER_STATUS.ORDER_CANCELLED) {
        picked.store.isChattable = false;
        picked.isChattable = false;
      }
    }

    state.room.data = data;
  },
  setRoomOrderState: (state, { orderNo, orderState }) => {
    const selected = cloneDeep(state.selectedRoom);
    if (Number(selected?.orderNo ?? 0) !== Number(orderNo ?? 0)) return;

    selected.order = {
      ...(selected.order ?? {}),
      orderNo,
      orderState
    };
    if (orderState === ORDER_STATUS.ORDER_CANCELLED) {
      selected.store.isChattable = false;
      selected.isChattable = false;
    }

    state.selectedRoom = selected;
  },

  setRoomStoreChatState: (state, { storeNo, isStoreChattable }) => {
    const selected = cloneDeep(state.selectedRoom);
    if (selected.store.storeNo === storeNo) {
      selected.store.isChattable = isStoreChattable;
      state.selectedRoom = selected;
    }
  },
  updateLastBubble: (state, { latestBubble, roomNo }) => {
    if (!latestBubble) return;

    const data = [...state.room.data];
    const selectedNo = roomNo;
    const idx = data.findIndex((room) => room.roomNo === selectedNo);
    const picked = data[idx];
    if (picked) {
      picked.lastBubble = latestBubble;
    }

    const now = new Date();
    data.sort((e1, e2) => {
      const d2 = e2?.lastBubble?.regDate
        ? new Date(e2?.lastBubble?.regDate).getTime()
        : now.getTime() - 1000 * 60 * 60 * 24 * 100;
      const d1 = e1?.lastBubble?.regDate
        ? new Date(e1?.lastBubble?.regDate).getTime()
        : now.getTime() - 1000 * 60 * 60 * 24 * 100;

      return d2 - d1;
    });
    state.room.data = data;
  },
  setRoomUnreadBubbleCount: (state, { roomNo, count }) => {
    const data = [...state.room.data];
    const selectedNo = roomNo;
    const idx = data.findIndex((room) => room.roomNo === selectedNo);

    const picked = data[idx];
    if (picked) {
      picked.unreadCount = count;
    }

    state.room.data = data;
  },

  plusNegoDeliveryFee: (state, { deliveryFee }) => {
    state.selectedRoom.order.deliveryFee += deliveryFee;
  },
  setActiveCount: (state, activeCount) => { // 채팅 뉴마크 관련
    state.activeCount = activeCount;
  }
};

const mergeRoomChats = (current, incoming, desiredRoomNo) => {
  const roomNo = Number(desiredRoomNo) || null;
  if (!roomNo) return [];
  const allowedTypes = new Set(['PLAIN', 'IMAGE', 'COPY', 'LEAVE']);

  const messages = [
    ...(Array.isArray(current) ? current : [current]),
    ...(Array.isArray(incoming) ? incoming : [incoming])
  ].filter(
    (message) =>
      message &&
      Number(message.roomNo) === roomNo &&
      allowedTypes.has(typeof message.type === 'string' ? message.type.toUpperCase() : '')
  );
  const seen = new Set();

  return messages
    .filter((message) => {
      if (message.bubbleNo === null || message.bubbleNo === undefined) return true;
      const key = `${Number(message.roomNo)}:${String(message.bubbleNo)}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort((a, b) => Number(a.bubbleNo ?? 0) - Number(b.bubbleNo ?? 0));
};

const appendInquiryRoom = (room, stateData) => {
  const rooms = [...stateData];
  const { roomType } = room;
  if (roomType === 'INQUIRY') rooms.push(room);
  return rooms;
};
const appendOrderRoom = (room, stateData, orderTab) => {
  const { ALL, INCOME, ON_GOING, RESERVATION } = CHAT_ORDER_TAB;
  const rooms = [...stateData];
  const { roomType, orderType, orderState } = room;
  const activeOrderTab = orderTab ?? ALL;
  if (roomType !== 'ORDER') return rooms;
  if (activeOrderTab === RESERVATION && orderType === 'TYPE_VISIT') {
    rooms.push(room);
  }
  if (activeOrderTab === INCOME && orderState === ORDER_STATUS.ORDER_INCOME) {
    rooms.unshift(room);
  }
  if (
    activeOrderTab === ON_GOING &&
    orderState !== ORDER_STATUS.ORDER_INCOME &&
    orderState !== ORDER_STATUS.ORDER_CANCELLED &&
    orderState !== ORDER_STATUS.DELIVERY_COMPLETED
  ) {
    rooms.push(room);
  }
  if (activeOrderTab === ALL) rooms.push(room);
  return rooms;
};

export default mutations;
